import * as React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";

import {
  makeGetRequest,
  makePostRequest
} from "../../../utils/utils";
import swal from "sweetalert";

function ServiceProViderAddModal() {

  const navigate = useNavigate();

  // const addCommitee = () => {
  //   var element = document.getElementById("successfullAdd");
  //   element.classList.toggle("hideModal");
  // };
  const [showLoader, setShowLoader] = React.useState(false);

  const [allbuilding, setallbuilding] = React.useState([]);
  const [allwing, setallwing] = React.useState([]);
  const [allapartment, setallapartment] = React.useState([]);

  const [buildingval, setbuildingval] = React.useState("");
  const [wingval, setwingval] = React.useState("");
  const [apartmentval, setapartmentval] = React.useState("");
  const [ownerName, setOwnerName] = React.useState("");
  const [ownerId, setOwnerId] = React.useState("");
  const [selectedBuild, setSelectedBuilding] = React.useState("");
  const [selectedWing, setSelectedWing] = React.useState("");
  const [selectedApartment, setSelectedApartment] = React.useState("");

  const [apartBuilErrMsg] = React.useState("");
  const [apartWingErrMsg] = React.useState("");
  const [apartNameErrMsg] = React.useState("");

  const [apartmentIdList, setApartmentIdList] = React.useState([]);
  const [ownerIdList, setOwnerIdList] = React.useState([]);

  const handlechangebuilding = (e) => {
    setbuildingval(e.target.value);
    setwingval("");
    setapartmentval("");
    winglisting(e.target.value);

    try {
      let idx = e.target.selectedIndex;
      let dataset = e.target.options[idx].dataset;
      // let selectedBuild = dataset.isd;
      setSelectedBuilding(dataset.isd);

      // let tempName = selectedBuild + "/";
      // setUniqAptName(tempName);
    } catch (e) {}
  };

  const handlechangewing = (e) => {
    setwingval(e.target.value);
    setapartmentval("");
    apartmentlisting(buildingval, e.target.value);

    let idx = e.target.selectedIndex;
    let dataset = e.target.options[idx].dataset;
    // let selectedWing = dataset.isd;

    setSelectedWing(dataset.isd);
    // let tempName = uniqAptName + selectedWing + "/";
    // setUniqAptName(tempName);
  };

  async function handlechangapartment(e) {

    if(apartmentIdList.includes(e.target.value))
    {
      swal("Apartment is already allocated to this service provider", "Please select another apartment", "warning",{
        timer:2000,
        buttons:false
      });
    }
    else
    {
      let aptName = "";
      // let tempName;
      setShowLoader(true);
      var str = e.target.value;
      setapartmentval(str);
  
      let idx = e.target.selectedIndex;
        let dataset = e.target.options[idx].dataset;
       setSelectedApartment(e.target.value)
       aptName = selectedBuild + "/" + selectedWing + "/" + dataset.isd;
      let inputData = {
        uniq_apt_name: aptName,
      };
      await makePostRequest(
        "resident/getresidentbyuniqaptname/",inputData
      )
        .then((response) => {
          console.log(response);
          if (response.data.data.length>0) {
            // for(var i=0;i<=response.data.data.rows.length;i++)
            // {
            //     if(response.data.data.rows[i].)
            // }
            console.log(response.data.data);
             
              if(response.data.data.length>1)
              {
                  for(var i=0;i<response.data.data.length;i++)
                  {
                    if(response.data.data[i].user_type=="tenent")
                    {
                      setOwnerName(response.data.data[i].fname+' '+response.data.data[i].lname);
                      setOwnerId(response.data.data[i].resident_id)
                    }
                  }
              }
              else
              {
                setOwnerName(response.data.data[0].fname+' '+response.data.data[0].lname);
                setOwnerId(response.data.data[0].resident_id)
  
              }
              
            
          }
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          swal("There was an error!", err, "warning");
        });
    }
   
  }

  async function buildinglist() {
    var bodyFormData = new FormData();
    await makeGetRequest(
      "building/getall/" + localStorage.getItem("socityid"),
      bodyFormData
    )
      .then((response) => {
        console.log("Building Response ", response);
        if (response.data.status === "1") {
          var data1 = response.data.data.rows;
          setallbuilding(data1);
        } else {
          setallbuilding([]);
        }
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  async function winglisting(id) {
    setShowLoader(true);
    await makeGetRequest("wing/getbybuildingid/" + id)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          setallwing(data1);
        } else {
          setallwing([]);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        swal("There was an error!", err, "warning");
      });
  }

  async function apartmentlisting(buildid, wingid) {
    setShowLoader(true);
    await makeGetRequest("apartment/getallocatednames/" + buildid + "/" + wingid)
      .then((response) => {
        if (response.data.status === "1") {
          var data1 = response.data.data;
          console.log(response.data.data)
          setallapartment(data1);
        } else {
          setallapartment([]);
        }
        setShowLoader(false);
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", err, "warning");
      });
  }


   // add Serviced Provider
   async function HireServiceProvider() {
   
    if(selectedApartment)
    {
    apartmentIdList.push(selectedApartment)
    ownerIdList.push(ownerId);
     let inputdata = {
      service_provider_id:localStorage.getItem('service_provider_id'),
      apartment_id_list:apartmentIdList,
      owner_id_list:ownerIdList

       };
       
      await makePostRequest("serviceProvider/update", inputdata)
        .then((response) => {
          if (response.data.data !== undefined) {
            swal("Success", "ServiceProvider Hired Successfully", "success", {
              timer: 1000,
              buttons: false,
            });

            // navigate(
            //   "/DetailsViewOfServicePro/" +
            //   localStorage.getItem('service_provider_id')
            // )
          }
        })
        .catch((err) => {
          console.log(err);
          swal("There was an error!", "more error details", "warning");
        });
        
        let historyInputdata = {
          owner_id:ownerId,
          service_provider_id:localStorage.getItem('service_provider_id'),
          apartment_id:selectedApartment,
          service_start_date:new Date(),
          is_service_stopped:false
           };
           
          await makePostRequest("serviceproviderhistory/insert", historyInputdata)
            .then((response) => {
              if (response.data.data !== undefined) {
                   
                navigate(
                  "/DetailsViewOfServicePro/" +
                  localStorage.getItem('service_provider_id')
                )
              }
            })
            .catch((err) => {
              console.log(err);
              swal("There was an error!", "more error details", "warning");
            });

        }
        else
        {
          swal("Warning", "Please select all details", "warning",{
            timer:2000,
            buttons:false
          });
        }
      }

  React.useEffect(() => {
    buildinglist();
    if(localStorage.getItem('apartmentIdList')&&localStorage.getItem('ownerIdList'))
    {
      setApartmentIdList(localStorage.getItem('apartmentIdList').split(','));
      setOwnerIdList(localStorage.getItem('ownerIdList').split(','));
    }
  }, []);

  return (
    <>
      <div id="successfullAdd">
        <Grid container spacing={3} className="addCommitee1">
          <Grid item xs={12} md={12}>
            <div className="modalInput">
              <SearchIcon />
              <input className="modalInputSt" placeholder="Search here" />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">
              Select Building <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="inputSt"
              value={buildingval}
              // onChange={event => handlechangebuilding(event,option.building_name )}
              onChange={handlechangebuilding}
            >
              <option value="" disabled>
                Select Building
              </option>
              {allbuilding.map((option) => (
                <option
                  key={option.building_id}
                  value={option.building_id}
                  data-isd={option.building_name}
                >
                  {option.building_name}
                </option>
              ))}
            </select>
            <p className="errorField">{apartBuilErrMsg}</p>
          </Grid>
          <Grid item xs={12} md={6}>
            <label className="tabsLabel">
              Select Wing <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="inputSt"
              value={wingval}
              onChange={handlechangewing}
            >
              <option value="" disabled>
                Select Wing
              </option>
              {allwing.map((option) => (
                <option
                  key={option.wing_id}
                  value={option.wing_id}
                  data-isd={option.wing_name}
                >
                  {option.wing_name}
                </option>
              ))}
            </select>
            <p className="errorField">{apartWingErrMsg}</p>
          </Grid>

          <Grid item xs={12} md={6}>
            <label className="tabsLabel">
              Select Apartment <span style={{ color: "red" }}>*</span>
            </label>
            <select
              className="inputSt"
              value={apartmentval}
              onChange={handlechangapartment}
            >
              <option value="" disabled>
                Select Apartment
              </option>
              {allapartment.map((option) => (
                <option key={option.apartment_id} value={option.apartment_id} data-isd={option.apartment_no}>
                  {option.apartment_no}
                </option>
              ))}
            </select>
            <p className="errorField">{apartNameErrMsg}</p>
          </Grid>

          <Grid item xs={12} md={6}>
            <label className="tabsLabel">
              Selected Owner name <span style={{ color: "red" }}>*</span>
            </label>
            <input value={ownerName} className="inputSt" />
          </Grid>

          <Grid item xs={12} md={12}>
            <div className="modalMainBtMain">
              <Button className="modalMainBt" onClick={HireServiceProvider}>
                Add Apartment
              </Button>
            </div>
          </Grid>
        </Grid>

        <Grid container spacing={3} className="addCommitee2">
          <Grid item xs={12} md={12}>
            <div className="succesMain">
              <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfz3upZJUzgki4bn27faJf6gPIIo7Yo5HxZg&usqp=CAU" />
              <h4>Success !</h4>
              <p>
                Apartment added <br />
                successfully
              </p>
            </div>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}
export default ServiceProViderAddModal;
